module.exports = __webpack_public_path__ + "img/image03.d56f86e2.jpg";